import React from 'react';
import sponsors from '../sponsors.json';

export default function Sponsors() {
  return (
    <div className="sponsors-carousel-wrapper">
      <h2>Supported By</h2>
      <div className="sponsor-carousel">
        {sponsors.map((sponsor) => (
          <a
            key={sponsor.name}
            href={sponsor.website}
            target="_blank"
            rel="noopener noreferrer"
            className="sponsor-card"
          >
            <img
              src={`/logos/${sponsor.logo}`}
              alt={sponsor.name}
              className="sponsor-logo"
            />
          </a>
        ))}
      </div>

      <style jsx>{`
        .sponsors-carousel-wrapper {
          width: 100%;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 1rem;
          box-sizing: border-box;
        }

        h2 {
          margin-bottom: 1rem;
          font-size: 0.5rem;
          text-align: center;
        }

        .sponsor-carousel {
          display: flex;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          gap: 2rem;
          padding: 1rem 0;
        }

        .sponsor-card {
          flex: 0 0 auto;
          scroll-snap-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 80px;
          min-width: 150px;
          max-width: 200px;
          border-radius: 6px;
          transition: transform 0.2s ease;
        }

        .sponsor-card:hover {
          transform: scale(1.05);
        }

        .sponsor-logo {
          max-height: 100%;
          max-width: 100%;
          object-fit: contain;
        }

        /* Optional: Hide scrollbar for cleaner look */
        .sponsor-carousel::-webkit-scrollbar {
          display: none;
        }
        .sponsor-carousel {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}
